// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 199) return "js/views.js";
	if (chunkId === 818) return "js/auth.js";
	if (chunkId === 571) return "js/settings.js";
	// return url for filenames based on template
	return undefined;
};